<div #anchorToOpen (click)="openPopup()"><qpoint-icon [iconType]="'solid'" [icon]="'ellipsis-h'"></qpoint-icon></div>
